
import React from 'react';

interface RecipeInstructionsProps {
  instructions: string[];
  isQuickRecipe?: boolean;
}

const RecipeInstructions: React.FC<RecipeInstructionsProps> = ({ instructions, isQuickRecipe }) => {
  // For quick recipes, hide instructions if they only contain the generic text
  if (isQuickRecipe && instructions.length === 1 && 
      instructions[0]?.toLowerCase().includes("prepare and cook ingredients as desired")) {
    return null;
  }

  return (
    <div className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">Instructions</h2>
      {instructions.length > 0 ? (
        <ol className="list-decimal pl-5 space-y-4">
          {instructions.map((instruction, index) => (
            <li key={index} className="pl-2">{instruction}</li>
          ))}
        </ol>
      ) : (
        <p className="text-muted-foreground">No instructions listed</p>
      )}
    </div>
  );
};

export default RecipeInstructions;
